import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getEstimatedCampaignRecipientCount = {
  name: "getEstimatedCampaignRecipientCount" as const,
  input: z.object({
    groups: z.array(zExt.objectId()),
    excludedGroups: z.array(zExt.objectId()),
    subscriptionType: createEnum(MarketingChannel),
  }),
  output: z.object({ count: z.number() }),
};
